<ngx-loading [show]="loading" [config]="{fullScreenBackdrop : true}"></ngx-loading>

<div class="container-login"  >
  <div class="wrap-login">

<div class="row">
        <div class="col-sm-12 col-md-6 col-xl-6 col-xl-6"  style="color:#000;font-size:30px;font-family: open-sans">
                <img routerLink="" src="assets/images/logo.png" style="    width: 60%;">

        </div>



            <div class="col-sm-12 col-md-6 col-xl-6 col-xl-6 form-group" *ngIf='userStatus === 0; else AlreadyLoggedIn'  >
                    <form [formGroup]="loginform" (ngSubmit)="onSignin(f)" #f="ngForm"  >

                      <span style="font-size: 22px; font-weight:bold; color: #9b7544;     padding-bottom: 54px;">User Login </span>

                            <div class="wrap-inputlogin form-group" style="margin-top:25px;">

                            <input type="text" name="email" id="email" placeholder="Enter email Id or Mobile number"
                            [(ngModel)]="loginform.email" class="inputlogin form-control" formControlName="email" required>


				                		<span class="symbol-inputlogin">
                							<i class="fa fa-envelope" aria-hidden="true"></i>
                						</span>

                            </div>

                            <div *ngIf="( loginform.get('email').hasError('required') || loginform.get('email').hasError('pattern') ) && loginform.get('email').touched">

                            <div class="error" style="color:red;font-size:10px" *ngIf="loginform.get('email').hasError('required') && loginform.get('email').touched">
                                Email/Mobile is required
                            </div>
                            <div class="error" style="color:red;font-size:10px" *ngIf="loginform.get('email').hasError('pattern') && loginform.get('email').touched">
                                  Enter Correct Email Id
                            </div>
                            </div>


                            <div class="wrap-inputlogin form-group">

                            <input type="password" placeholder="Enter Password" name="password" id="password"
                            [(ngModel)]="loginform.password" class="inputlogin form-control" formControlName="password" required>
                            <span class="symbol-inputlogin">
                							<i class="fa fa-lock" aria-hidden="true"></i>
                						</span>

                            </div>

                            <div *ngIf="( loginform.get('password').hasError('required')) && loginform.get('password').touched">

                                <div class="error" style="color:red;font-size:10px" *ngIf="loginform.get('password').hasError('required') && loginform.get('password').touched">
                                Password is required
                                </div>

                              </div>




                            <div class="row">
                                    <div class="col-12">
                                            <button  class="btn login" type="submit" [disabled]="!loginform.valid">Sign In</button>
                                    </div>



  <div id="loginbtn" style="margin-top:30px; margin-left: 15px; height:50px; color: #9b7544">
      <span routerLink="/signup"> >> Create your Account

    </span>
        </div>

        <div class="col-12" id="linkcursor">
            <span style="color: #9b7544" routerLink="/forgotpassword"> >> Forgot Password

          </span>
              </div>

                            </div>




                            </form>

            </div>
          </div>

   </div>
 </div>

        <div style="background-color: #cb983f;text-align:center;" >
                    <div class="footer-copyright">
                            <div class="container-fluid" style="font-family: open-sans; font-size:25px; color: #fff">
                             © 2018 PETCART

                            </div>
                        </div>

            </div>
            <ng-template #AlreadyLoggedIn>
                    <div  *ngIf='userStatus === 1' style="color:#cb983f;font-size:15px">
                            user is Already Logged In...
                            <p>Automatically redirect to Dashboard after {{ctimer}} seconds</p>
                           <a routerLink=""> <p> click here to redirect to Homepage</p></a>
                        </div>
            </ng-template>
